import Director from './Html5ChatSim';
import * as helper from './../../../Assets/Js/helper';
import {CDNHandler} from '../../../Assets/Js/CDNHandler';

helper.one(window, 'load', function () {
	const cdn = new CDNHandler();
	cdn.getCdnDomain()
		.then(domain => {
			new Director(domain);
		});
});
